import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import axios from 'axios';
import { environment } from '../../../../environments/environment';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-new-jumper',
  templateUrl: './new-jumper.component.html',
  styleUrls: [
    '../../incidents/new-incident/new-incident.component.scss',
    './new-jumper.component.scss',
    '../../../components/modal/modal.component.scss'
  ]
})
export class NewJumperComponent implements OnInit {
  token = window.sessionStorage.getItem('token');
  userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'));

  mode = 'Create';
  userBase = '';

  // qualification filter vars
  qualsQuery;
  tqualsQuery;
  originalQuals = [];
  originalTQuals = [];

  // define base jumper object
  jumper = {
    id: '',
    lastDayOff: '',
    baseId: ''
  };

  // endpoint vars
  qualifications = [];
  traineeQualifications = [];

  // define form sections
  sections = [
    {
      title: 'Jumper Information',
      data: [
        {
          input: true,
          required: true,
          placeholder: 'First Name',
          key: 'firstName'
        },
        {
          choice: {},
          dropdown: true,
          label: 'Position',
          key: 'basePosition',
          options: [
            {
              name: '',
              value: ''
            },
            {
              name: 'Assistant Foreman',
              value: 'Assistant Foreman'
            },
            {
              name: 'Base Manager',
              value: 'Base Manager'
            },
            {
              name: 'Crewmember',
              value: 'Crewmember'
            },
            {
              name: 'Foreman',
              value: 'Foreman'
            },
            {
              name: 'Spotter',
              value: 'Spotter'
            },
            {
              name: 'Squadleader',
              value: 'Squadleader'
            }
          ]
        },
        {
          input: true,
          required: true,
          placeholder: 'Last Name',
          key: 'lastName'
        },
        {
          choice: {},
          dropdown: true,
          label: 'Spotter',
          key: 'spotter',
          options: [{
            name: '',
            value: ''
          },
            {
              name: 'Spotter',
              value: 'Spotter'
            },
            {
              name: 'Trainee',
              value: 'Trainee'
            }
          ]
        },
        {
          width: 25,
          required: true,
          input: true,
          placeholder: 'Phone Number',
          key: 'phoneNumber'
        },
        {
          width: 25,
          input: true,
          placeholder: 'Grade',
          key: 'grade'
        },
        {
          choice: {},
          dropdown: true,
          label: 'First Aid',
          key: 'firstAid',
          options: [
            {
              name: '',
              value: ''
            },
            {
              name: 'Advanced First Aid',
              value: 'Advanced First Aid'
            },
            {
              name: 'EMT',
              value: 'EMT'
            },
            {
              name: 'OEC',
              value: 'OEC'
            },
            {
              name: 'Paramedic',
              value: 'Paramedic'
            },
            {
              name: 'Wilderness First Aid',
              value: 'Wilderness First Aid'
            }
          ]
        },
        {
          width: 25,
          choice: {},
          dropdown: true,
          label: 'Tour',
          key: 'tour',
          options: [
            {
              name: 'PFT',
              value: 'PFT'
            },
            {
              name: '18/8',
              value: '18/8'
            },
            {
              name: '13/13',
              value: '13/13'
            },
            {
              name: 'Temp',
              value: 'TEMP'
            }
          ]
        },
        {
          width: 25,
          input: true,
          type: 'date',
          key: 'lastDayOff',
          placeholder: 'Last Day Off'
        },
        {
          choice: {},
          dropdown: true,
          label: 'Rigger',
          key: 'rigger',
          options: [
            {
              name: '',
              value: ''
            },
            {
              name: 'Master Rigger',
              value: 'Master Rigger'
            },
            {
              name: 'Senior Rigger',
              value: 'Senior Rigger'
            },
            {
              name: 'Trainee',
              value: 'Trainee'
            }
          ]
        },
        {
          width: 25,
          checkbox: true,
          label: 'Active Status ?',
          key: 'activeStatus'
        },
        {},
        {
          input: true,
          key: 'weight',
          placeholder: 'Exit Weight'
        }
      ]
    }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toast: ToastService
  ) {}

  async ngOnInit() {
    this.userBase = this.userInfo.basecode;
    this.jumper.baseId = this.userInfo.baseId;

    this.refreshQualifications();

    // if we see an '/:id' instead of '/new' in the URL,
    // we are in "update" mode instead of "create" mode
    let url = window.location.href;
    let id = url.slice(url.lastIndexOf('/') + 1, url.length);
    if (id.includes(';')) {
      id = url.slice(url.lastIndexOf('/') + 1, url.indexOf(';'));
    }
    if (id !== 'new') {
      this.mode = 'Update';
      let jumper = await axios.get(environment.API_URL + '/jumpers/' + id, {
        headers: { Authorization: 'Bearer ' + this.token }
      });
      this.jumper = jumper.data;
      if (this.jumper.lastDayOff) {
        let date = this.jumper.lastDayOff.split('-');
        this.jumper.lastDayOff =
          date[0] + '-' + date[1] + '-' + date[2].substr(0, 2);
      }

      // get any qualifications associated with the jumper
      let jumperQualifications = await axios.get(
        environment.API_URL + '/JumpersQuals?jumperId=' + id,
        {
          headers: { Authorization: 'Bearer ' + this.token }
        }
      );

      // check off checkboxes that we have jumperquals for
      let jumperQuals = jumperQualifications.data.value;
      if (!jumperQuals) {
        jumperQuals = [];
      }
      jumperQuals.forEach((jumperQual) => {
        if (jumperQual.type === 'Q') {
          this.qualifications.forEach((q) => {
            if (q.id === jumperQual.qualsId) {
              q.checked = true;
            }
          });
        } else if (jumperQual.type === 'T') {
          this.traineeQualifications.forEach((tq) => {
            if (tq.id === jumperQual.qualsId) {
              tq.checked = true;
            }
          });
        }
      });
    }

    // populate dropdown options according to formData.sections
    this.sections.forEach((section) => {
      section.data.forEach((datum) => {
        if (datum.dropdown) {
          if (this.jumper[datum.key]) {
            let choice = datum.options.filter((option) => {
              let optString = option.value;
              let dataString = this.jumper[datum.key];
              return optString.toString() === dataString.toString();
            });
            if (choice.length) {
              datum.choice = choice[0];
            }
          }
        }
      });
    });
  }

  sort = (array, key) => {
    array.sort((a, b) => {
      var keyA = a[key];
      var keyB = b[key];
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });
    return array;
  };

  refreshQualifications = async () => {
    this.qualifications = [];
    this.traineeQualifications = [];

    // get endpoint data for form options
    let allQualifications = await axios.get(environment.API_URL + '/Quals', {
      headers: { Authorization: 'Bearer ' + this.token }
    });
    let qualifications = allQualifications.data.value.filter((qual) => {
      return qual.active
    })
    qualifications.forEach((qual) => {
      let q = qual;
      let tq = qual;
      q.type = 'Q';
      tq.type = 'T';
      this.qualifications.push({
        acronym: qual.Acronym,
        type: 'Q',
        name: qual.title + ' | ' + qual.Acronym,
        id: qual.id,
        title: qual.title,
        value: qual.value,
        checked: false
      });
      this.traineeQualifications.push({
        acronym: qual.Acronym,
        type: 'T',
        name: qual.title + ' | ' + qual.Acronym,
        id: qual.id,
        title: qual.title,
        value: qual.value,
        checked: false
      });
    });

    this.qualifications = this.sort(this.qualifications, 'title');
    this.traineeQualifications = this.sort(this.traineeQualifications, 'title');

    // for filtering
    this.originalQuals = this.qualifications;
    this.originalTQuals = this.traineeQualifications;
  };

  // dropdown handler
  onSelectedDropdownItem = (event, datum) => {
    this.jumper[datum.key] = event.value;
  };

  submitJumperQuals = (id) => {
    const options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };
    let url = environment.API_URL + '/JumpersQuals/' + id + '/add';

    let quals = [];

    // see which qualifications are checked
    this.traineeQualifications.forEach((qual) => {
      if (qual.checked) {
        quals.push({ id: qual.id, type: qual.type });
      }
    });
    this.qualifications.forEach((qual) => {
      if (qual.checked) {
        quals.push({ id: qual.id, type: qual.type });
      }
    });

    axios
      .post(url, quals, options)
      .then((response) => {
        this.toast.show(
          'Jumper was ' + (this.mode === 'Create' ? 'creat' : 'updat') + 'ed',
          'success'
        );
        this.router.navigate(['/jumpers']);
      })
      .catch((error) => {
        console.dir(error);
      });
  };

  filterQuals = (event) => {
    this.qualifications = this.originalQuals;

    // find quals that match query
    let filteredQuals = [];
    this.qualifications.forEach((qual) => {
      let title = qual.title.toLowerCase();
      if (title.includes(this.qualsQuery.toLowerCase())) {
        filteredQuals.push(qual);
      }
    });

    // dedupe quals
    let uniqueQuals = [...new Set(filteredQuals)];
    this.qualifications = uniqueQuals;
  };

  filterTQuals = (event) => {
    this.traineeQualifications = this.originalTQuals;

    // find quals that match query
    let filteredQuals = [];
    this.traineeQualifications.forEach((qual) => {
      let title = qual.title.toLowerCase();
      if (title.includes(this.tqualsQuery.toLowerCase())) {
        filteredQuals.push(qual);
      }
    });

    // dedupe quals
    let uniqueQuals = [...new Set(filteredQuals)];
    this.traineeQualifications = uniqueQuals;
  };

  submitForm = (data) => {
    const options = {
      headers: { Authorization: 'Bearer ' + this.token }
    };
    let url = environment.API_URL + '/jumpers/add';

    if (this.mode === 'Create') {
      delete this.jumper.id;
      axios
        .post(url, this.jumper, options)
        .then((response) => {
          let id = response.data;
          this.submitJumperQuals(id);
        })
        .catch((error) => {
          this.toast.show('Error creating Jumper.', 'error');
          console.dir(error);
        });
    } else if (this.mode === 'Update') {
      url = environment.API_URL + '/jumpers' + '/' + this.jumper.id + '/update';
      axios
        .post(url, this.jumper, options)
        .then((response) => {
          this.submitJumperQuals(this.jumper.id);
        })
        .catch((error) => {
          this.toast.show('Error updating Jumper.', 'error');
          console.dir(error);
        });
    }
  };

  cancel = () => {
    this.router.navigate(['/jumpers']);
  };
}
